// extracted by mini-css-extract-plugin
export default {"numberDisplay":"NumberDisplay_numberDisplay__9YuQ5"};